import { Observable } from 'rxjs/Observable';
import { Component, OnInit, Input, OnDestroy, ViewChild } from '@angular/core';
import { Tool, Company, Deliverable, Activity, Milestone } from 'toolbandi-ui-lib';
import { Search, SharedDataService, CrudService, MessageService, Attach } from 'elbuild-ui-lib-core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AttachmentInputComponent } from 'elbuild-ui-componentslib';


@Component({
	selector: 'app-deliverable-edit',
	templateUrl: './deliverable-edit.component.html',
	styleUrls: ['./deliverable-edit.component.scss']
})
export class DeliverableEditComponent implements OnInit, OnDestroy {

	loading: boolean = true;
	deliverable: Deliverable;
	tab: string;
	editable: string;

	@Input()
	activityid: number;

	@Input()
	attach: Attach;


	companyid: number;

	title: string;
	selected: { milestone: any };
	search: { milestone: Search };

	@ViewChild('deliverableattachment', {}) attachmentInput: AttachmentInputComponent;
	showAdvancedSearch: boolean = true;


	constructor(
		private route: ActivatedRoute,
		private sharedDataService: SharedDataService,
		private toolService: CrudService<Deliverable>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private milestoneService: CrudService<Milestone>,
		private activeModal: NgbActiveModal
	) {

		this.selected = {
			milestone: undefined,
		};
		this.search = {
			milestone: new Search('milestone')

		};

	}

	ngOnDestroy(): void {
		this.sharedDataService.addCommonData('route', undefined);
	}

	ngOnInit() {
		this.route.params.subscribe(params => {
			const id = +params['id'];
			if (id) {
				this.load(id);
			} else {
				this.deliverable = new Deliverable();
				this.title = 'deliverable-create';

				this.loading = false;
			}
		});
	}

	load(id: number): void {
		this.loading = true;
		this.toolService.getEntity(Deliverable, 'deliverable', id).subscribe(deliverable => {
			this.deliverable = deliverable;
			this.title = 'deliverable-edit';
			this.loading = false;


			this.findMilestone(this.deliverable.milestoneid);

		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.deliverable'));
			this.deliverable = undefined;
			this.loading = false;
		});

	}



	findMilestone(cid: number): void {
		if (cid) {
			this.milestoneService.getEntity(Milestone, 'milestone', cid).subscribe((c: Milestone) => {
				this.selected.milestone = c;
			});
		}
	}



	dismiss(): void {
		this.activeModal.dismiss();
	}


	upload() {

		return this.attachmentInput.upload().subscribe(data => {
			this.messageService.sendSuccess(
				this.translateService.instant('labels.deliverable-save-success'),
				this.translateService.instant('labels.success')
			);
			this.activeModal.close(this.deliverable);
		}, ({ error }) => {
			this.messageService.sendError(
				error.msg ? error.msg : error,
				this.translateService.instant('labels.event-save-error')
			);
		});
	}

	submit(): void {

		this.deliverable.milestoneid = this.selected.milestone.id;


		if (!this.deliverable.id) {
			this.deliverable.activityid = this.activityid;

			this.toolService.createEntity(Deliverable, 'deliverable', this.deliverable).subscribe(response => {
				this.deliverable = response;
				this.attachmentInput.eid = this.deliverable.id;
				this.upload();
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		} else {
			this.toolService.saveEntity(Deliverable, 'deliverable', this.deliverable).subscribe(response => {
				this.deliverable = response;
				this.upload();
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		}
	}
}
